import {AfterContentInit, Component, EventEmitter, Input, Output, TemplateRef, ViewChild} from '@angular/core';

@Component({
    selector: 'lib-rc-table-header',
    template: `<ng-template #tableHeader>
  <div (click)="headerClick($event)" class="rc-table-header">
    <ng-content></ng-content>
  </div>
</ng-template>`,
    styles: [``]
})
export class RcTableHeaderComponent implements AfterContentInit {
    @Input() data: any = {};
    @Output() headerClickCallback: EventEmitter<any> = new EventEmitter();

    @ViewChild('tableHeader', {read: TemplateRef}) tableHeader;

    constructor() {

    }
    ngAfterContentInit() {
    }

    headerClick($event) {
        if (this.headerClickCallback.observers.length) {
            $event.stopPropagation();
            this.headerClickCallback.emit(this.data);
        }
    }

}